module.exports = __webpack_public_path__ + "static/media/spinSounds_2.9e0c92a2.mp3";